import { Product } from "@domain/product/models/Product";
import { Shipment } from "@domain/shipment";
import type { MinimumOrderQuantityType, SupplierProduct } from "@domain/suppliers/models/Supplier";
import { PurchaseOrder } from "./PurchaseOrder";
import { Note } from "./Notes";

export interface PurchaseOrderItem {
    id?: string;
    /** Supplier for the linked supplier–product row (with companyId and productId). */
    supplierId?: string | null;
    product: Product;
    productionStartDate?: Date;
    productionReadyDate?: Date;
    shipment?: Shipment;
    quantity?: number;
    /** MOQ snapshot at order time */
    minimumOrderQuantity?: number;
    /** Order quantity must be a multiple of this value (snapshot at order time). */
    orderInMultiplesOf?: number;
    purchasePrice?: number;
    currency?: string;
    minimumOrderQuantityType?: MinimumOrderQuantityType;
    supplierProduct?: SupplierProduct | null;
    status: PurchaseOrderItemStatus;
    statusUpdatedAt?: Date;
    purchaseOrder?: PurchaseOrder;
    sort?: number;
    notes?: Note[];
    createdAt?: Date;
    updatedAt?: Date;
    eta?: Date;
    recommendedQuantity?: number;
}

export enum PurchaseOrderItemStatus {

    PLANNED = 'planned',

    IN_PRODUCTION = 'in production',
    PRODUCTION_READY = 'production ready',

    IN_TRANSIT = 'in transit',
    ARRIVED = 'arrived',

    IN_DELIVERY = 'in delivery',
    AVAILABLE = 'available',
}

export const PurchaseOrderItemStatusColors = {
    [PurchaseOrderItemStatus.PLANNED]: '#4CAF50',

    [PurchaseOrderItemStatus.IN_PRODUCTION]: '#FF9800',
    [PurchaseOrderItemStatus.PRODUCTION_READY]: '#FFB300',

    [PurchaseOrderItemStatus.IN_TRANSIT]: '#2196F3',
    [PurchaseOrderItemStatus.ARRIVED]: '#FF5722',

    [PurchaseOrderItemStatus.IN_DELIVERY]: '#9C27B0',
    [PurchaseOrderItemStatus.AVAILABLE]: '#4CAF50',
}

export const activePurchaseOrderItemStatuses = [
    PurchaseOrderItemStatus.PLANNED,
    PurchaseOrderItemStatus.IN_PRODUCTION,
    PurchaseOrderItemStatus.PRODUCTION_READY,
    PurchaseOrderItemStatus.IN_TRANSIT,
    PurchaseOrderItemStatus.ARRIVED,
    PurchaseOrderItemStatus.IN_DELIVERY,
]